export enum REQUEST_TYPES {
	GET_TASK_PRIORITIES = 'GET_TASK_PRIORITIES',
	GET_TASK_PRIORITIES_BY_ORIGINS = 'GET_TASK_PRIORITIES_BY_ORIGINS',
	GET_TASK_PRIORITIES_BY_FILTER = 'GET_TASK_PRIORITIES_BY_FILTER',
	DO_ACTION_CREATE_TASK_PRIORITY = 'DO_ACTION_CREATE_TASK_PRIORITY',
	DO_ACTION_EDIT_TASK_PRIOIRITY = 'DO_ACTION_EDIT_TASK_PRIOIRITY',
	DO_ACTION_DELETE_TASK_PRIORITY = 'DO_ACTION_DELETE_TASK_PRIORITY',
}
